import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";

/**
 * @method apiGetCategory
 * @method apiRedeemCampaign
 */

export default {
    /**
     * @param {String} token*/

    GetBlob() {
        const url = `/nestle/nescafe_streetcafe/QRcode.json`;
        return new Promise((resolve, reject) => {
            BzbsCustom.apiGetCustom(url)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }
};
